import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';

import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import DigitalAssistant from './DigitalAssistant';
import IntegrationInfo from './IntegrationInfo';
import NudgesSetting from './NudgesSetting';
import VisitorSettings from './VisitorSettings';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import InactivePopUpSettings from './InactivePopUpSettings';
import MultliLanguages from './MultliLanguages';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  putAPI_Update_Ingetration,
  gAPI_Ingetration,
  gAPI_Internal_Property_By_Id,
  gAPI_Property_List_By_Group,
  dAPI_Delete_Ingetration,
} from '../../../../../constants/APIs';

import CodeSnippet from './CodeSnippet';
import { NavLink } from 'react-router-dom';
import { faHandSpock } from '@fortawesome/free-regular-svg-icons';
import {
  faPalette,
  faLanguage,
  faComment,
  faLocationArrow,
  faHome,
} from '@fortawesome/free-solid-svg-icons';
import { faSnapchat, faWpforms } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BubblePosition from './BubblePosition';
import PersistentMenuForm from './PersistentMenuForm';
import Example from './Example';
import LiveChat from './LiveChat';
import RuleSetting from './RuleSetting';
import Features from './Features';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Validation from '../../../../../components/Validation';
import WelcomeMessage from './WelcomeMessage';
import chatbot_appearance from '../images/Chatbot Appearance.png';
import pre_post_form from '../images/Pre&post_form.png';
import property_img from '../images/properties_img.png';
import language_img from '../images/language.png';

function IntegrationList({ match, history, propertyId, domains, locale }) {
  const integrationId = match.params.id;
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [apperanceVisible, setApperanceVisible] = useState(false);
  const [nudgesVisible, setNudgesVisible] = useState(false);
  const [positionVisible, setPositionVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [languageVisible, setLanguageVisible] = useState(false);
  const [welcomeMsgVisible, setWelcomeMsgVisible] = useState(false);
  const [publishVisible, setPublishVisible] = useState(false);
  const [persistentMenuVisible, setPersistentMenuVisible] = useState(false);
  const [liveChatVisible, setLiveChatVisible] = useState(false);
  const [ruleVisible, setRuleVisible] = useState(false);
  const [featuresVisible, setFeaturesVisible] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [integrationPropertyData, setIntegrationPropertyData] = useState([]);
  const localeOptions = [
    { id: "en", name: "English", desc: "English", code: "en", locale: "en" },
    { id: "hi", name: "Hindi", desc: "हिंदी", code: "hi", locale: "hi" },
    {
      id: "id",
      name: "Indonesian",
      desc: "bahasa Indonesia",
      code: "id",
      locale: "id",
    },
    { id: "es", name: "Spanish", desc: "Español", code: "es", locale: "es" },
    { id: "fr", name: "French", desc: "français", code: "fr", locale: "fr" },
    { id: "de", name: "German", desc: "Deutsche", code: "de", locale: "de" },
    { id: "zh", name: "Chinese", desc: "简体中文", code: "ZH-簡", locale: "zh" },
    {
      id: "vi",
      name: "Vietnamese",
      desc: "Tiếng Việt",
      code: "vi",
      locale: "vi",
    },
    { id: "th", name: "Thai", desc: "ไทย", code: "th", locale: "th" },
    { id: "ja", name: "Japanese", desc: "日本語", code: "ja", locale: "ja" },
    {
      id: "zh-TW",
      name: "Chinese (Traditional)",
      desc: "繁體中文",
      code: "ZH-繁",
      locale: "hk",
    },
    {
      id: "tl",
      name: "Tagalog (Filipino)",
      desc: "Tagalog (Filipino)",
      code: "tl",
      locale: "tl",
    },
    { id: "af", name: "Afrikaans", desc: "Afrikaans", code: "af", locale: "af" },
    { id: "ko", name: "Korean", desc: "한국어", code: "ko", locale: "ko" },
    { id: "mi", name: "Maori", desc: "Maori", code: "mi", locale: "mi" },
    { id: 'ar', name: 'Arabic', desc: "عربي", code: "ar", locale: "ar" },
    { id: 'ru', name: 'Russian', desc: "Русский", code: "ru", locale: "ru" },
  ];
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };


  const liveChat = () => {
    setPropertyVisible(false);
    setWelcomeMsgVisible(false);
    setLiveChatVisible(true);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };


  const welcomeMessage = () => {
    setPropertyVisible(false);
    setWelcomeMsgVisible(true);
    setLiveChatVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };

  const property = () => {
    setPropertyVisible(true);
    setWelcomeMsgVisible(false);
    setLiveChatVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };

  const appearance = () => {
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setWelcomeMsgVisible(false);
    setApperanceVisible(true);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };

  const nudges = () => {
    setWelcomeMsgVisible(false);
    setLiveChatVisible(false);
    setPropertyVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(true);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };

  const chatForm = () => {
    setWelcomeMsgVisible(false);
    setPropertyVisible(false);
    setApperanceVisible(false);
    setLiveChatVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(true);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };

  const publishCode = () => {
    setWelcomeMsgVisible(false);
    setLiveChatVisible(false);
    setPropertyVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(true);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };
  const setPosition = () => {
    setWelcomeMsgVisible(false);
    setPropertyVisible(false);
    setApperanceVisible(false);
    setLiveChatVisible(false);
    setNudgesVisible(false);
    setPositionVisible(true);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };
  const setLanguage = () => {
    setWelcomeMsgVisible(false);
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(true);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };
  const persistentMenu = () => {
    setWelcomeMsgVisible(false);
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(true);
    setRuleVisible(false);
    setFeaturesVisible(false);
  };

  const ruleForm = () => {
    setWelcomeMsgVisible(false);
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(true);
    setFeaturesVisible(false);
  }

  const features = () => {
    setWelcomeMsgVisible(false);
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setPersistentMenuVisible(false);
    setRuleVisible(false);
    setFeaturesVisible(true);
  }
  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setPropertyData(res.data);
      })
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        // console.log(res.data);   
        setIntegration(res.data);
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Internal_Property_By_Id}/${res.data.properties[0]}?group_id=${getGroupID()}`,
        })
          .then((json) => {
            setIntegrationPropertyData(json.data);

          });
      })
      .catch((err) => console.log('err', err));
  }, [integrationId]);

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
  }, []);
  const LoadIntegration = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setIntegration(res.data);
      })
  };

  const saveIntegration = (data) => {
    const { list, name, botSetting } = data;
    if (botSetting) {
      updateModel.botSettings = botSetting;
    }
    if (list) {
      updateModel.properties = list;
    }
    if (name) {
      updateModel.name = name;
    }

    console.log('update', updateModel);

    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Ingetration}/${integration.id
        }?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          LoadIntegration();
          setTimeout(() => {
            NotificationManager.success(
              '',
              'Integration Updated',
              3000,
              null,
              null,
              'success'
            );
          }, 100);
        }
      });

  };

  const saveLiveChatSettings = (data) => {
    updateModel.liveChatSetting = data.liveChat;
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Ingetration}/${integration.id
        }?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then(() => {
        NotificationManager.success(
          "",
          "Live chat settings update successfully",
          3000,
          null,
          null,
          "success"
        );
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
        })
          .then((res) => {
            setIntegration(res.data);
          })
      });
  };
  const RedirectToDemo = () => {
    var url = `${process.env.REACT_APP_BOT_DEMO
      }?gid=${getGroupID()}&iid=${integrationId}`;
    window.open(url, '_blank');
  };

  const modelNudges = integration
    ? integration.channelDetails.initiationRuleset[0].nudges.map((nudge) => {
      if (nudge.eyeCatcher && nudge.greeting) {
        return {
          eyeCatcher: {
            code: nudge.eyeCatcher.query.code,
            filterTags: null,
          },
          greeting: {
            code: nudge.greeting.query.code,
            filterTags: null,
          },
          delayInMilliseconds: nudge.delayInMilliseconds,
          delayInMillisecondsInMobile: nudge.delayInMillisecondsInMobile,
          disabledInDesktop: nudge.disabledInDesktop,
          disabledInMobile: nudge.disabledInMobile,
          buttons: nudge.buttons,
        };
      }
    })
    : null;

  let updateModel = integration
    ? {
      name: integration.name,
      level: integration.level,
      properties: [...integration.properties],
      sessionTimeoutInSeconds: integration.sessionTimeoutInSeconds,
      baseUrl: integration.channelDetails.baseUrl,
      homePageRoute: integration.channelDetails.homePageRoute,
      defaultLanguage: 'en-US',
      defaultRuleDescription: 'Default',
      defaultRuleNudges: [...modelNudges],
      botSettings: { ...integration.botSettings },
      menuEnabled: integration.channelDetails.menuEnabled,
      persistentMenu: integration.channelDetails.persistentMenu,
      liveChatSetting: integration.liveChat,
      engagementRules: [...integration.engagementRules],
      ruleDisabled: integration.ruleDisabled
    }
    : null;

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  /** FIXME: */
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration} / ${integrationId} /? group_id = ${getGroupID()}`,
    })
      .then((res) => console.log('res', res))
      .then(
        setTimeout(() => {
          history.push('/app/pages/integration/channels');
        }, 300)
      );
  };

  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/channels' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Select properties
                          </p>
                          <p className="mb-4 text-small">
                            Select the properties that are visible through this
                            integration
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${featuresVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon simple-icon-game-controller`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => features()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Features
                          </p>
                          <p className="mb-4 text-small">
                            Select the features you want enabled on the website chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${apperanceVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faPalette} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => appearance()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Appearance
                          </p>
                          <p className="mb-4 text-small">
                            Choose your digital assistant's name, avatar and
                            setup your colours
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  {((integration !== undefined && integration.properties !== undefined && integration.properties.length === 1) &&
                    (integrationPropertyData?.domains && integrationPropertyData?.domains !== null && integrationPropertyData?.domains.length > 0 &&
                      integrationPropertyData?.domains[0].type !== undefined && integrationPropertyData?.domains.filter((f) => f.type == 'BusinessOperator').length > 0)) ? null : <div
                        className={`mb-3 integration ${nudgesVisible ? 'integration--active' : ''
                          }`}
                      >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faHandSpock} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => nudges()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Nudges (Obsolete)
                          </p>
                          <p className="mb-4 text-small">
                            Setup proactive messages to engage the website
                            visitors
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>}

                  {((integration !== undefined && integration.properties !== undefined && integration.properties.length > 1) ||
                    (integrationPropertyData?.domains && integrationPropertyData?.domains !== null && integrationPropertyData?.domains.length > 0 && integrationPropertyData?.domains[0].type !== undefined
                      && integrationPropertyData?.domains.filter((f) => f.type === 'BusinessOperator' || f.type === 'UtilityProviders').length > 0)) && <div
                        className={`mb-3 integration ${welcomeMsgVisible ? 'integration--active' : ''
                          }`}
                      >
                      <div className="glyph">
                        <FontAwesomeIcon icon={faHome} className="fa" />
                      </div>
                      <NavLink
                        to="#"
                        className="w-40 w-sm-100"
                        onClick={(e) => welcomeMessage()}
                      >
                        <Row>
                          <Colxx xxs="12" md="10">
                            <p className="list-item-heading mb-1 color-theme-1">
                              Welcome Message
                            </p>
                            <p className="mb-4 text-small">
                              This is the very first message that shows up when customer starts a chat.
                            </p>
                          </Colxx>
                          <Colxx xxs="12" md="2">
                            <div className="glyph">
                              <div
                                className={`glyph-icon-min iconsminds-arrow-forward-2`}
                              />
                            </div>
                          </Colxx>
                        </Row>
                      </NavLink>
                      <Separator />
                    </div>}
                  {((integration !== undefined && integration.properties !== undefined && integration.properties.length === 1) && (integrationPropertyData?.domains && integrationPropertyData?.domains !== null && integrationPropertyData?.domains.length > 0 &&
                    integrationPropertyData?.domains[0].type !== undefined && integrationPropertyData?.domains.filter((f) => f.type === 'BusinessOperator').length > 0)) ? null : <div
                      className={`mb-3 integration ${positionVisible ? 'integration--active' : ''
                        }`}
                    >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLocationArrow} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setPosition()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Position (Obsolete)
                          </p>
                          <p className="mb-4 text-small">
                            Control the position of chat widget on your website
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>}
                  <div
                    className={`mb-3 integration ${formVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faWpforms} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => chatForm()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Pre & Post Chat form
                          </p>
                          <p className="mb-4 text-small">
                            Collect website visitor details, before they can
                            start the chat
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${persistentMenuVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faWpforms} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => persistentMenu()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Persistent Menu (Obsolete)
                          </p>
                          <p className="mb-4 text-small">
                            Setup your persistent menu
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min  iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${languageVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLanguage()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Language
                          </p>
                          <p className="mb-4 text-small">
                            Select the languages for the chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min  iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${liveChatVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faComment} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => liveChat()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Live Chat
                          </p>
                          <p className="mb-4 text-small">
                            Select the settings for the live chat
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min  iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${ruleVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-file-clipboard-file---text`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => ruleForm()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Engagement Rules
                          </p>
                          <p className="mb-4 text-small">
                            Engage customers with conditional targeting
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration d-none ${publishVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-monitor---tablet`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => publishCode()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Publish your digital assistant
                          </p>
                          <p className="mb-4 text-small">
                            Copy the code snippet to install your digital
                            assistant
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div className='d-none'>
                    <Button
                      color="dark"
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={RedirectToDemo}
                    >
                      Preview
                    </Button>

                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                  <Example url={property_img} />
                </Fragment>
              )}
              {featuresVisible && (
                <Fragment>
                  <Features
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    locale={locale}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                </Fragment>
              )}
              {apperanceVisible && (
                <Fragment>
                  <DigitalAssistant
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    locale={locale}
                  />
                  {/*"https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                  <Example url={chatbot_appearance} />
                </Fragment>
              )}
              {welcomeMsgVisible && (
                <Fragment>
                  <WelcomeMessage
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                </Fragment>
              )}
              {nudgesVisible && (
                <Fragment>
                  <NudgesSetting
                    integrationId={integration.id}
                    integration={integration}
                    nudges={
                      integration.channelDetails.initiationRuleset[0].nudges
                    }
                    locale={locale}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/nudges.png" /> */}
                </Fragment>
              )}
              {formVisible && (
                <Fragment>
                  <VisitorSettings
                    integrationId={integration.id}
                    visitor={integration.botSettings.visitorSettings}
                  />

                  <InactivePopUpSettings
                    integrationId={integration.id}
                    popup={integration.botSettings.inactivePopUpWarning}
                    number={1}
                    defaultMessage={
                      'Thank you for chatting to us. It is our pleasure serving you. Is there anything I can further assist with?'
                    }
                    defaultSeconds={300}
                    header={'Inactivity Warning Message'}
                    minTime={300}
                  />

                  <InactivePopUpSettings
                    integrationId={integration.id}
                    popup={integration.botSettings.inactivePopUpSession}
                    number={2}
                    defaultMessage={
                      'The session is closed. You are most welcome to visit us again anytime, thank you.'
                    }
                    defaultSeconds={600}
                    header={'Inactive Popup Session End Settings'}
                    minTime={600}
                  />

                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/popup.png" /> */}
                  <Example url={pre_post_form} />
                </Fragment>
              )}
              {publishVisible && <CodeSnippet integration={integration} propertyId={propertyId} saveIntegration={saveIntegration} />}
              {positionVisible && (
                <Fragment>
                  <BubblePosition
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/position.png" /> */}
                </Fragment>
              )}
              {persistentMenuVisible && (
                <Fragment>
                  <PersistentMenuForm
                    localeOptions={localeOptions}
                    integration={integration}
                    persistentMenus={integration.channelDetails.persistentMenu}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/web_menu.png" /> */}
                </Fragment>
              )}
              {languageVisible && (
                <Fragment>
                  <MultliLanguages
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/languages.png" /> */}
                  <Example url={language_img} />
                </Fragment>
              )}
              {liveChatVisible && (
                <Fragment>
                  <LiveChat
                    liveChatSettings={integration.liveChat}
                    propertyData={propertyData}
                    saveIntegration={saveLiveChatSettings}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/languages.png" /> */}
                </Fragment>
              )}
              {ruleVisible && (
                <Fragment>
                  <RuleSetting
                    LoadIntegration={LoadIntegration}
                    integrationId={integration.id}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/nudges.png" /> */}
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, domains, locale } = settings;

  return {
    propertyId,
    domains,
    locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(IntegrationList));
